module.exports = __webpack_public_path__ + "img/back.4beec817.svg";